import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Radio, Row, Select } from 'antd';
import { BackBtn } from '@comm/BackBtn';
import { queryDictExpend } from '@api/core/dict';

const { Option } = Select;
const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expendType: [],
    };
  }

  componentDidMount() {
    this.loadExpendType();
  }

  loadExpendType = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(values);
      }
    });
  };

  start = () => {};

  render() {
    const { getFieldDecorator } = this.props.form;
    const { expendType } = this.state;
    const { dataInfo } = this.props;
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.start}
            htmlType="submit"
          >
            确认
          </Button>
        </div>
        <Card>
          <Row>
            <Col span={10}>
              <FormItem label="预算科目" {...ItemLayout}>
                {getFieldDecorator('budgetType', {
                  rules: [{ required: true, message: '请选择预算科目' }],
                  initialValue: dataInfo.budgetType
                    ? `${dataInfo.budgetType}`
                    : dataInfo.budgetType,
                })(
                  <Select onChange={this.handleTypeChange}>
                    {expendType.map(item => {
                      return <Option key={item.value}>{item.key}</Option>;
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="分摊金额" {...ItemLayout}>
                {getFieldDecorator('price', {
                  rules: [{ required: true, message: '请输入报销金额!' }],
                  initialValue: dataInfo.price,
                })(<Input placeholder="报销金额" addonAfter="元" type="number" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="分摊类型" {...ItemLayout}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请设置分摊类型!' }],
                  initialValue: dataInfo.type,
                })(
                  <RadioGroup>
                    <RadioButton value="0">单次分摊</RadioButton>
                    <RadioButton value="1">多次分摊</RadioButton>
                  </RadioGroup>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="说明" labelCol={{ span: 4 }} wrapperCol={{ span: 18 }}>
                {getFieldDecorator('remark', {
                  initialValue: dataInfo.remark,
                })(
                  <Input.TextArea
                    placeholder="备注"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}
export default Form.create()(BaseForm);



// WEBPACK FOOTER //
// ./src/components/finance/apportion/FormBase.js